module.exports = __webpack_public_path__ + "components/city-nav/static/tickets-2ce2c9add3e6e8aadfa364c918f7122b.svg";